import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faBars, faTimes, faGlobe, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/Header.css';
import logo from '../assets/images/logo.png';
import logo2 from '../assets/images/logo2.png';
import borsaIstanbulLogo from '../assets/images/borsaistanbul.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { isDarkMode, toggleTheme } = useTheme();
  const { language, toggleLanguage, t } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="header-container">
        {/* Logo */}
        <Link
          to="/"
          className="logo"
          onClick={() => setIsMenuOpen(false)}
          aria-label={t('nav.home')}
        >
          <div className="logo-image">
            <img
              src={isDarkMode ? logo : logo2}
              alt="MASGOLD"
              className="logo-img"
            />
          </div>
        </Link>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </button>

        {/* Navigation */}
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link 
                to="/milyem" 
                className={location.pathname === '/milyem' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.milyem')}
              </Link>
            </li>
            <li>
              <Link 
                to="/hakkimizda" 
                className={location.pathname === '/hakkimizda' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link 
                to="/uyum" 
                className={location.pathname === '/uyum' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.compliance')}
              </Link>
            </li>
            <li>
              <Link 
                to="/bilgi-toplum-hizmetleri" 
                className={location.pathname === '/bilgi-toplum-hizmetleri' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.bilgiToplum')}
              </Link>
            </li>
            <li>
              <Link 
                to="/iletisim" 
                className={location.pathname === '/iletisim' ? 'nav-link active' : 'nav-link'}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </nav>

        {/* App Store Icons */}
        <div className="app-store-icons">
          <a 
            href="https://apps.apple.com/sn/app/masgold/id6753982731" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faApple} />
          </a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.aifasoft.masgold&hl=tr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faGooglePlay} />
          </a>
          <a 
            href="https://maps.app.goo.gl/TjTEKj5YAsQu3RP59" 
            target="_blank" 
            rel="noopener noreferrer"
            className="app-icon"
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </a>
        </div>

        {/* Language Toggle */}
        <div className="language-toggle">
          <button 
            className="language-btn"
            onClick={toggleLanguage}
            title={language === 'tr' ? 'Switch to English' : 'Türkçe\'ye Geç'}
          >
            <FontAwesomeIcon icon={faGlobe} />
            <span>{language === 'tr' ? 'EN' : 'TR'}</span>
          </button>
        </div>

        {/* Toggle Switch */}
        <div className="toggle-switch">
          <input 
            type="checkbox" 
            id="toggle" 
            className="toggle-input" 
            checked={isDarkMode}
            onChange={toggleTheme}
          />
          <label htmlFor="toggle" className="toggle-label">
            <FontAwesomeIcon icon={faSun} className="toggle-icon sun-icon" />
            <FontAwesomeIcon icon={faMoon} className="toggle-icon moon-icon" />
          </label>
        </div>

        <div className="borsa-corner-logo">
          <img src={borsaIstanbulLogo} alt="Borsa Istanbul" className="borsa-logo-img" />
        </div>
      </div>
    </header>
  );
};

export default Header;
